// Used for `ng serve`. Note: `ng serve` alone does NOT run the Pages
// Functions in ./functions (it only serves the Angular app). To test the
// full stack locally (storefront + API + chatbot together), run:
//   npm run pages:dev
// which builds the app and serves it plus the functions on one origin
// (usually http://localhost:8788). apiBaseUrl stays relative so it works
// in both cases without editing this file.
export const environment = {
  production: false,
  apiBaseUrl: '/api',
};
